import React from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
} from '@/components/ui/alert-dialog';
import { ShieldAlert } from 'lucide-react';

const ForcePasswordChangeModal = ({ open }) => {
  const navigate = useNavigate();
  const { businessId } = useParams();
  const location = useLocation();

  const onChangePasswordPage = location.pathname.includes('/change-password');

  const handleChangePassword = () => {
    navigate(`/business/${businessId}/settings/change-password`);
  };

  return (
    <AlertDialog open={open && !onChangePasswordPage}>
      <AlertDialogContent onEscapeKeyDown={(e) => e.preventDefault()}>
        <AlertDialogHeader>
          <div className="flex items-center gap-3 mb-1">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-amber-100">
              <ShieldAlert className="h-5 w-5 text-amber-600" />
            </div>
            <AlertDialogTitle>Password Change Required</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-sm text-gray-600">
            You are using a temporary password set by your administrator. For security reasons, you must change your password before continuing.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={handleChangePassword}>
            Change Password Now
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ForcePasswordChangeModal;
